/**
 *
 * @param  {...string} args paths with or without "/" to combine ("products",
 * "other-slug", "/other")
 * @returns {string} combined path
 *
 * A helper utility for building out paths from strings. Can be used to create
 * new reusable path builders for dynamic links (@see {@link productPathBuilder})
 */
const pathMaker = (...args) => {
  const deSlashed = args.map(arg => arg.replace(/^\/|\/$/g, ''))
  const path = deSlashed.join('/') + '/'
  if (path.length && path.charAt(0) !== '/') return '/' + path
  return path
}

/**
 * Helper function to build product paths without needing to string interpolate
 * every time.
 * @param {string} productSlug
 * @returns {string} product path
 *
 * Takes a product slug as argument and returns the path to product
 * `/products/{slug}`
 */
const productPathBuilder = productSlug => {
  return productSlug ? pathMaker('products', productSlug) : ''
}

/**
 * Helper function to build bundle paths without needing to string interpolate
 * every time.
 * @param {string} productSlug
 * @returns {string} product path
 *
 * Takes a bundle slug as argument and returns the path to bundle
 * `/bundles/{slug}`
 */
const bundlePathBuilder = productSlug => {
  return pathMaker('bundles', productSlug)
}
module.exports = {
  pathMaker,
  productPathBuilder,
  bundlePathBuilder,
}
